/* CRO: open header dropdown/mega menus on hover (desktop only).
   Top-level items with a real URL become click-through links since
   hover already reveals the panel. Touch devices keep tap-to-toggle. */
(function () {
  const DESKTOP = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const OPEN_DELAY = 60;
  const CLOSE_DELAY = 250;

  function init() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.croHoverBound) return;
      const details = menu.querySelector('details');
      const summary = details ? details.querySelector('summary') : null;
      if (!details || !summary) return;
      menu.dataset.croHoverBound = 'true';

      let openTimer = null;
      let closeTimer = null;

      const open = () => {
        if (details.hasAttribute('open')) return;
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        if (!details.hasAttribute('open')) return;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      };

      menu.addEventListener('mouseenter', () => {
        if (!DESKTOP.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(open, OPEN_DELAY);
      });

      menu.addEventListener('mouseleave', () => {
        if (!DESKTOP.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(close, CLOSE_DELAY);
      });

      // On hover-capable devices a mouse click on the top-level item
      // navigates to its URL instead of toggling the already-open panel.
      const url = summary.dataset.croUrl;
      if (url && url !== '#' && url !== '') {
        summary.addEventListener('click', (event) => {
          if (!DESKTOP.matches) return;
          if (event.detail === 0) return; // keyboard "click" keeps toggle behaviour
          event.preventDefault();
          window.location.href = url;
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
